import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CreatePaymentCardRequest,
  ListPaymentCardsRequest,
  ListPaymentCardsResponse,
  MerchantApiService,
  PaymentCard as ApiPaymentCard,
  SetDefaultPaymentCardRequest,
  UpdatePaymentCardRequest,
} from '@vendasta/billing';
import { convertApiPaymentCardDetails, PaymentCard } from './payment-card';

@Injectable({ providedIn: 'root' })
export class PaymentCardService {
  constructor(private apiService: MerchantApiService) {}

  setDefaultCard(merchantId: string, cardId: string): Observable<HttpResponse<null>> {
    const request = new SetDefaultPaymentCardRequest({
      merchantId,
      cardId,
    });
    return this.apiService.setDefaultPaymentCard(request);
  }

  getFirstPaymentCard(merchantId: string): Observable<PaymentCard | null> {
    return this.getAll(merchantId).pipe(map((cards: PaymentCard[]) => (cards.length ? cards[0] : null)));
  }

  getAll(merchantId: string): Observable<PaymentCard[]> {
    const req = new ListPaymentCardsRequest({
      merchantId: merchantId,
    });
    return this.apiService.listPaymentCards(req).pipe(
      map((res: ListPaymentCardsResponse) => (res && res.paymentCard ? res.paymentCard : [])),
      map((paymentCards: ApiPaymentCard[]) => {
        return paymentCards.map((c: ApiPaymentCard) => convertApiPaymentCardDetails(c));
      }),
    );
  }

  update(merchantId: string, token: string): Observable<HttpResponse<null>> {
    const request = new UpdatePaymentCardRequest({ merchantId: merchantId, stripeToken: token });
    return this.apiService.updatePaymentCard(new UpdatePaymentCardRequest(request));
  }

  create(merchantId: string, token: string): Observable<HttpResponse<null>> {
    const request = new CreatePaymentCardRequest({ merchantId: merchantId, stripeToken: token });
    return this.apiService.createPaymentCard(new CreatePaymentCardRequest(request));
  }
}
